import { createAction } from "@reduxjs/toolkit";

export const clearCacheAction = createAction("CLEAR_CACHE");
